import { useAtomValue } from 'jotai';
import { authState } from './authState';

const useUser = () => {
  const { user } = useAtomValue(authState);
  return user;
};

export default useUser;
